import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout, Modal } from 'antd';

import './App.css';
import LoginScreen from './containers/onboarding/LoginScreen';
import AuthReturn from './containers/onboarding/AuthReturn';
import ProfileScreen from './containers/profiling/ProfileScreen';
import { RegularText } from './components/common/Text';
import modalIcon from './images/common/errorImage.png';
import { hideError } from './actions/index';
import NewPendingOnboardingHome from './containers/NewPendingOnboarding/NewPendingOnboardingHome';
import OnboardingRequest from './containers/OnboardingRequest/OnboardingRequest';
import CenterProfileScreen from './containers/center-profiling/CenterProfileScreen';
import FeaturedCenterList from './containers/featured-centers/FeaturedCenterList';
import FeaturedCenterCitySelection from './containers/featured-centers/FeaturedCenterCitySelection';
import ApprovalRequests from './containers/approval-requests/ApprovalRequests';
import CenterDataUpdateRequests from './containers/center-data-requests/CenterDataUpdateRequests';
import VaccinationSponsors from './components/Vaccination/vaccinationSponsors';
import AddUser from './containers/add-user/AddUser';
import networkCenterProfile from './containers/network-center-profile/networkCenterProfile';
import doctorEmpanelment from './containers/DoctorEmpanelment/DoctorEmpanelment';
import CreateNewRequest from './containers/OnboardingRequest/CreateNewRequest';
import centerListing from './containers/center-listing/centerListing';
const { Content } = Layout;

const ModalIcon = styled.img`
  width: 2rem;
`;

const ModalText = styled(RegularText)`
  font-size: 1rem;
`;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: true,
    };
    console.log({ props });
  }

  hideModal = () => {
    this.props.hideError();
  };

  render() {
    return (
      <Layout>
        <Content>
          <Router>
            <Switch>
              <Route path="/" exact component={LoginScreen} />
              <Route path="/auth/return" component={AuthReturn} />
              <Route
                path="/doctor-profile/:doctorId"
                component={ProfileScreen}
              />
              <Route path='/create-new-request' component={CreateNewRequest} />
              <Route path='/all-centers' component={centerListing} />
              <Route
                path="/center-profile/:centerId"
                component={CenterProfileScreen}
              />
              <Route path="/home" component={OnboardingRequest} />
              <Route path="/on-the-fly" component={NewPendingOnboardingHome} />
              <Route path="/featured-centers" component={FeaturedCenterList} />
              <Route
                path="/featured-centers-city"
                component={FeaturedCenterCitySelection}
              />
              <Route path="/approval-requests" component={ApprovalRequests} />
              <Route path="/add-user" component={AddUser} />
              <Route path="/network-center-profile" component={networkCenterProfile} />
              <Route path="/doctor-empanelment" component={doctorEmpanelment} />
              <Route
                path="/center-data-requests"
                component={CenterDataUpdateRequests}
              />
              <Route
                path="/vaccination-sponsors"
                component={VaccinationSponsors}
              />
            </Switch>
          </Router>
          <Modal
            title={this.props.appError.errorTitle}
            visible={this.props.appError.hasError}
            onOk={this.hideModal}
            closable={false}
            style={{ textAlign: 'center' }}
          >
            <ModalIcon src={modalIcon} />
            <ModalText>{this.props.appError.errorDesc}</ModalText>
          </Modal>
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  appError: state.app.appError,
});

const mapDispatchToProps = (dispatch) => ({
  hideError: () => {
    dispatch(hideError());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
